import { format } from 'date-fns'
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { IconButton, Stack, Typography } from '@mui/material'

export const DateRangeHeader = ({
  customHeaderCount,
  monthDate,
  increaseMonth,
  decreaseMonth
}: ReactDatePickerCustomHeaderProps) => {
  const disableLeftButton = customHeaderCount === 1
  const disableRightButton = customHeaderCount === 0

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <IconButton
        onClick={decreaseMonth}
        disabled={disableLeftButton}
        sx={{
          opacity: disableLeftButton ? 0 : 1
        }}
      >
        <KeyboardArrowLeftIcon />
      </IconButton>
      <Typography justifySelf="center">{format(monthDate, 'MMMM yyyy')}</Typography>
      <IconButton
        onClick={increaseMonth}
        disabled={disableRightButton}
        sx={{
          opacity: disableRightButton ? 0 : 1
        }}
      >
        <KeyboardArrowRightIcon />
      </IconButton>
    </Stack>
  )
}
